import { Component, OnInit, Input, ChangeDetectorRef, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import * as Chart from 'chart.js';
import { ChartRenderer } from './controller/chart.renderer';
import { DataModel } from './model/base/data.model';
import { ChartType } from './model/chart-type.model';
import { ChartTypeDataInterface } from './model/interface/chart-type-data-interface';
import { callLifecycleHooksChildrenFirst } from '@angular/core/src/view/provider';
import { Colors } from '../../../models/enums/colors.enum';
import { HttpClient } from 'selenium-webdriver/http';
import { HttpService } from '../../../services/http.service';
import { ISubscription } from 'rxjs/Subscription';


@Component({
    selector: 'app-chart',
    templateUrl: './chart.component.html',
    styleUrls: ['./chart.component.scss']
})
export class ChartComponent implements OnInit, OnDestroy {
    chart = [];

    @Input() type: ChartTypeDataInterface;
    @Input() title: string;
    @Input() systemId: string;
    @Input() subSystemId: string = null;
    @Input() chartId: number;

    @ViewChild('canvas') canvas: ElementRef;

    data: Array<[Array<number>, string, boolean]>;
    label: Array<string>;
    width:  string = '100%';
    height: string = '18vh';
    subscription: ISubscription;

    constructor(private http: HttpService, private cdref: ChangeDetectorRef) { }

    ngAfterViewInit() {
        if(!this.isMap()){
            this.initView();

            this.subscription = this.http.graphData().subscribe(data => {
                 let filtered = data.filter(sys => sys.systemId == this.systemId && sys.subSystemId == this.subSystemId);
                 if (filtered.length > 0){
                     let graphData = filtered[0];
                    //  console.log(graphData);

                     ChartRenderer.shift(this.chart);
                     ChartRenderer.addData(this.chart, [graphData.value, Math.floor(Math.random() * 20)]);
                     ChartRenderer.update(this.chart)
                 }
             });
        }

    }

    initView() {

        Chart.defaults.global.defaultFontColor = '#40467c';
        Chart.defaults.global.defaultFontSize = 10;

        // replace with api call using system id to get data
            this.data = [
                [[12, 9, 3, 4, 21, 12, 9, 3, 4, 21], Colors.blue, this.type.fill]
                // [[2, 5, 12, 1, 9, 2, 5, 12, 1, 9], Colors.lightBlue, this.type.fill]
            ];
            this.label = ['27s', '24s', '21 s', '18 s', '15 s', '12 s', '9 s', '6 s', '3 s', 'Now'];

        let chartData: DataModel = new DataModel((<HTMLCanvasElement>this.canvas.nativeElement))
            .appendLabel(this.label);

        this.data.forEach((tuple) => {
            chartData.appendData(tuple[0], tuple[1], tuple[2]);
        });

        this.chart = ChartRenderer.render(this.type, this.chartId, chartData);
    }

    isMap(){
        return this.type == ChartType.MAP;
    }

    ngOnInit() {

    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/app/components/charts/chart/chart.component.ts